import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_s2t87zapm7: FaireBrandEntity = {
  token: "b_s2t87zapm7",
  type: "brand",
  name: "Pat's Monograms, LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/a04fed28895533a21886e2f187641767a0bf0336f22e580ee6d9e1bce2944898.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/710caf0258f7a6f9c77083009e196cfc6e7804f18185b36d97b76797e7a99b09.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a04fed28895533a21886e2f187641767a0bf0336f22e580ee6d9e1bce2944898.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/710caf0258f7a6f9c77083009e196cfc6e7804f18185b36d97b76797e7a99b09.jpeg",
  location: "Southaven, MS, USA",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Our collections focus on quality materials, thoughtful design, and styles that resonate with customers shopping for everyday gifts, gatherings, and special moments. From entertaining pieces and drinkware to accessories and lifestyle goods, our products are designed to merchandise easily and perform well in a wide range of retail environments.\n\nAll items are produced in-house with consistency and efficiency in mind, allowing retailers to confidently stock our designs in bulk. Each product arrives retail-ready and is created to fit seamlessly into gift shops, lifestyle boutiques, collegiate stores, and event-focused retail.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:12.914Z",
    importedBy: "entity-db-cli",
  },
};
